import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

const UIContext = createContext(null);

export const UIProvider = ({ children }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [isCaptionActionListOpen, setIsCaptionActionListOpen] = useState(true);
  const [isCaptionDataOpen, setIsCaptionDataOpen] = useState(true);
  const [isClockControlOpen, setIsClockControlOpen] = useState(true);
  const [selectedOrgId, setSelectedOrgId] = useState(() => {
    return localStorage.getItem('selectedOrgId') || '';
  });

  useEffect(() => {
    if (selectedOrgId) {
      localStorage.setItem('selectedOrgId', selectedOrgId);
    }
  }, [selectedOrgId]);

  const setDrawerOpen = useCallback((open) => setIsDrawerOpen(open), []);
  const toggleDrawer = useCallback(() => setIsDrawerOpen((prev) => !prev), []);
  const toggleCaptionActionList = useCallback(() => setIsCaptionActionListOpen((prev) => !prev), []);
  const toggleCaptionData = useCallback(() => setIsCaptionDataOpen((prev) => !prev), []);
  const toggleClockControl = useCallback(() => setIsClockControlOpen((prev) => !prev), []);
  const updateSelectedOrgId = useCallback((orgId) => setSelectedOrgId(orgId), []);

  const value = React.useMemo(() => ({
    isDrawerOpen,
    toggleDrawer,
    setDrawerOpen,
    isCaptionActionListOpen,
    toggleCaptionActionList,
    isCaptionDataOpen,
    toggleCaptionData,
    isClockControlOpen,
    toggleClockControl,
    selectedOrgId,
    updateSelectedOrgId,
  }), [
    isDrawerOpen, toggleDrawer, setDrawerOpen,
    isCaptionActionListOpen, toggleCaptionActionList,
    isCaptionDataOpen, toggleCaptionData,
    isClockControlOpen, toggleClockControl,
    selectedOrgId, updateSelectedOrgId,
  ]);

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
};

export const useUI = () => {
  const context = useContext(UIContext);
  if (!context) {
    throw new Error('useUI must be used within a UIProvider');
  }
  return context;
};

export default UIContext;
